/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { RightModel } from './right.model';
import { UserPhoneDtoModel } from './user-phone-dto.model';

export class UserModel {
  public uuid: string | undefined = undefined;
  public owner: string | undefined = undefined;
  public name: string | undefined = undefined;
  public email: string | undefined = undefined;
  public oldPassword: string | undefined = undefined;
  public password: string | undefined = undefined;
  public lang: string | undefined = undefined;
  public userPhoneDTO: UserPhoneDtoModel | null = null;
  public activeTo: string | undefined = undefined;
  public isNewUser: boolean | undefined = undefined;
  public companySuperAdmin: boolean | undefined = undefined;
  public userRights: RightModel[] | undefined = undefined;
  public activated: boolean | undefined = undefined;
}
